import sha256 from 'sha256'
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'admin-on-rest'

export default (type, params) => {
  const API_HOST = process.env.REACT_APP_API_URL

  // called when the user attempts to log in
  if (type === AUTH_LOGIN) {
    const { username, password } = params

    const request = new Request(`${API_HOST}/experts/login`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Basic ${new Buffer(`${username}:${sha256(password)}`).toString('base64')}`,
      }),
    })
    return fetch(request)
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText)
        }

        return response.json()
      })
      .then(({ accessToken }) => {
        console.log('RESPONSE', accessToken)
        localStorage.setItem('token', accessToken)
      })
  }
  // called when the user clicks on the logout button
  if (type === AUTH_LOGOUT) {
    localStorage.removeItem('token')
    return Promise.resolve()
  }
  // called when the API returns an error
  if (type === AUTH_ERROR) {
    const { status } = params
    if (status === 401 || status === 403) {
      localStorage.removeItem('token')
      return Promise.reject()
    }
    return Promise.resolve()
  }
  // called when the user navigates to a new location
  if (type === AUTH_CHECK) {
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject()
  }
  return Promise.reject('Unknown method')
}



// WEBPACK FOOTER //
// ./src/authClient.js